import { z } from 'zod';

import { type V3OutreachLink } from '@apps/web/features/phoebe_chat_v3/model/transcript';

export const CREATE_OUTREACH_TOOL_NAME = 'create_outreach';

// Only the id is read. The rest of the create receipt describes the outreach
// at creation time, and the outreach page is authoritative for all of it.
const createOutreachOutputSchema = z.object({
    outreach_id: z.uuid(),
});

export function parseV3OutreachLink({
    toolName,
    output,
}: {
    readonly toolName: string;
    readonly output: unknown;
}): V3OutreachLink | null {
    if (toolName !== CREATE_OUTREACH_TOOL_NAME) {
        return null;
    }
    const parsed = createOutreachOutputSchema.safeParse(output);
    if (!parsed.success) {
        return null;
    }
    return { kind: 'outreach-link', outreachId: parsed.data.outreach_id };
}
